import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2f2c8fd4 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _64722e0e = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _e9a4cf9e = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _4f91e7cd = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _6eef246d = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _0917c569 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _96ddb732 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _171d9f82 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _396b538b = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _758801ac = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _0a933d80 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _4c0cd910 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _cd8760d4 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _a210fa26 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1fe187a5 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _eb808d60 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _5025ec37 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _167eeaad = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _74ed8c0e = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _7630db6e = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _4d5d7857 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _871ce0b6 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _402e7ece = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _a1b41b98 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _9560040c = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _f33f8d2a = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _1877db6d = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _fc89a196 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _40346253 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _48a28a16 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _74c7b12c = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _7f45913e = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _6a9bf9c8 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _2434e280 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _2659357c = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _0c974562 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _5dd0787d = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _533ce83e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _32d1e086 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _64a4a293 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _2cd17613 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _7d820342 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _e0da1b00 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _d1d41ea6 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _050af870 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _37bf73fc = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _4cdec0b4 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _55065880 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _cd696270 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _5bf4bfa8 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _ef354c9a = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _0e4fb1fb = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _714e5304 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _d7ae7614 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _98ad3fae = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _3582338e = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _b12fe856 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _76a1d36a = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _194b943b = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _336961b4 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _cc683dec = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _e5750a46 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _3eedce30 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _96ccf630 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _472c7625 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _1bda7004 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _7e141a4e = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _0bc1e3c9 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _62e55e15 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _c382869a = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _765ac030 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _157b7206 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _a697e44c = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _535008c8 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _281f64b0 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _a7c44110 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _2f2c8fd4,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _64722e0e,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _e9a4cf9e,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _4f91e7cd,
    name: "calendar"
  }, {
    path: "/customer",
    component: _6eef246d,
    name: "customer"
  }, {
    path: "/details",
    component: _0917c569,
    name: "details"
  }, {
    path: "/goals",
    component: _96ddb732,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _171d9f82,
    name: "maisoku"
  }, {
    path: "/media",
    component: _396b538b,
    name: "media"
  }, {
    path: "/privacy",
    component: _758801ac,
    name: "privacy"
  }, {
    path: "/project",
    component: _0a933d80,
    name: "project"
  }, {
    path: "/response",
    component: _4c0cd910,
    name: "response"
  }, {
    path: "/sale",
    component: _cd8760d4,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _a210fa26,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1fe187a5,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _eb808d60,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _5025ec37,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _167eeaad,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _74ed8c0e,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _7630db6e,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _4d5d7857,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _871ce0b6,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _402e7ece,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _a1b41b98,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _9560040c,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _f33f8d2a,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _1877db6d,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _fc89a196,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _40346253,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _48a28a16,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _74c7b12c,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _7f45913e,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _6a9bf9c8,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _2434e280,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _2659357c,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _0c974562,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _5dd0787d,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _533ce83e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _32d1e086,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _64a4a293,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _2cd17613,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _7d820342,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _e0da1b00,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _d1d41ea6,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _050af870,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _37bf73fc,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _4cdec0b4,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _55065880,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _cd696270,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _5bf4bfa8,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _ef354c9a,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _0e4fb1fb,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _714e5304,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _d7ae7614,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _98ad3fae,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _3582338e,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _b12fe856,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _76a1d36a,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _194b943b,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _336961b4,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _cc683dec,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _e5750a46,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _3eedce30,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _96ccf630,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _472c7625,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _1bda7004,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _7e141a4e,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _0bc1e3c9,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _62e55e15,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _c382869a,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _765ac030,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _157b7206,
    name: "property-property",
    children: [{
      path: "contact",
      component: _a697e44c,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _535008c8,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _281f64b0,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _a7c44110,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
